export default "__VITE_ASSET__BCqcGMAr__"